<app-scroll-view class="scroll-view">
  <div class="content" #contentEl>
    <ng-container *ngIf="topItems?.length; else itemsElseTpl">
      <div class="session-top">
        <div class="group-lines">
          <div class="first-line" *ngIf="!!topItems?.length">
            <span
              class="text"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            >
              TOP {{ topItems.length }}
            </span>
          </div>

          <div class="second-line" *ngIf="!!infos?.length">
            <div class="item-content" *ngFor="let item of infos">
              <label
                class="label"
                [appBlockModalDrag]="!(isMobileModeObservable | async)"
                >{{ item.label }}:</label
              >
              <span
                class="value"
                [title]="item.value"
                [appBlockModalDrag]="!(isMobileModeObservable | async)"
                >{{ item.value }}</span
              >
            </div>
          </div>
        </div>

        <div>
          <div
            class="btn-export"
            #btnExportEl
            (click)="onBtnExportClick($event)"
          >
            <app-iconic
              class="icon"
              icon="assets/icons/floppy-disk.svg"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-iconic>
          </div>
        </div>

        <app-tooltip
          [target]="btnExportEl"
          verticalAlignment="top"
          horizontalAlignment="center"
        >
          Salvar XLS
        </app-tooltip>
      </div>

      <div class="session-center">
        <div
          class="chart"
          echarts
          [autoResize]="true"
          [options]="barChartOptions"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></div>
      </div>

      <div class="session-bottom">
        <div
          class="header-list"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        >
          <div class="column-label">{{ columnAlias }}</div>
          <div class="column-percent">Percentagem</div>
        </div>

        <app-list
          class="list"
          [items]="topItems"
          [keyExpr]="extractDisplayName"
          [scrollable]="false"
        >
          <ng-template listItem let-item="item" let-index="index">
            <div
              class="item"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            >
              <ng-template
                [ngTemplateOutlet]="itemLabelTpl"
                [ngTemplateOutletContext]="{
                  label: extractDisplayName(item, index)
                }"
              ></ng-template>
              <div class="percent">
                {{ extractPercent(item, index) | number : "0.0-2" }}%
              </div>
            </div>
          </ng-template>
        </app-list>
      </div>
    </ng-container>

    <ng-template #itemsElseTpl>
      <ng-container
        *ngIf="initialState; else noDataMsgTpl"
        [ngTemplateOutlet]="initialStateMsgTpl"
      ></ng-container>
    </ng-template>

    <ng-template #initialStateMsgTpl>
      <div
        class="initial-msg"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        {{ initialMsg }}
      </div>
    </ng-template>

    <ng-template #noDataMsgTpl>
      <div
        class="no-data-msg"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        {{ noDataMsg }}
      </div>
    </ng-template>
  </div>
</app-scroll-view>

<ng-template #itemLabelTpl let-label="label">
  <div class="label" [title]="label">
    {{ label }}
  </div>
</ng-template>

<app-loading-panel
  [visible]="loadingController.changes | async"
  [container]="contentEl"
></app-loading-panel>
